<template>
  <div>
    <v-dialog
      v-model="showModal"
      width="400px"
    >
      <v-card class="image-crop-modal pa-2" v-if="showModal">
        <div class="overflow-hidden mt-1">
          <cropper
            :src="internalSrc"
            :stencilProps="stencilProps"
            :defaultSize="defaultSize"
            @change="change"
          />
        </div>
        <v-card-actions>
          <div class="d-flex w-100 justify-space-between">
            <v-btn
              text
              color="grey"
              @click="showModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              color="secondary"
              @click="handleDone"
            >
              Done
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {Cropper} from 'vue-advanced-cropper'

export default {
  name: 'ImageCrop',
  components: {
    Cropper
  },
  props: {
    src: {
      type: String,
      require: true
    },
    stencilProps: {
      type: Object,
      require: false,
      default() {
        return {
          aspectRatio: 4 / 5
        }
      }
    }
  },
  data() {
    return {
      showModal: false,
      changes: null,
      internalSrc: this.src,
    }
  },
  watch: {
    showModal(newVal) {
      if(newVal) {
        this.changes = null;
        this.internalSrc = this.src;
      }
    },
    src() {
      this.internalSrc = this.src;
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    change({coordinates, canvas}) {
      this.changes = canvas;
    },
    handleDone() {
      if(this.changes) {
        this.$emit('change', this.changes.toDataURL("image/jpeg"))
      }

      this.showModal = false;
    },
    defaultSize({ visibleArea, imageSize, stencilRatio, sizeRestrictions }) {
      let height = imageSize.height;
      let width = imageSize.width;

      // Check width sizing
      if(width > sizeRestrictions.maxWidth) {
        width = sizeRestrictions.maxWidth;
      } else if(width < sizeRestrictions.minWidth) {
        width = sizeRestrictions.minWidth;
      }

      // Check height sizing
      if(height > sizeRestrictions.maxHeight) {
        height = sizeRestrictions.maxHeight;
      } else if(height < sizeRestrictions.minHeight) {
        height = sizeRestrictions.minHeight;
      }

      if(stencilRatio) {
        // This may need to be handled one day
      }

      return {
        height,
        width
      }
    }
  }
}
</script>

<style lang="scss">
.image-crop-modal {
  background-color: #C9C9C9;
}
</style>
